/**
 * Configuration Stripe pour DPEWizard
 * Définition des produits et tarifs
 */
export interface StripeProduct {
  id: string;
  name: string;
  description: string;
  mode: 'subscription' | 'payment';
  price: number; // en euros
  features: string[];
  popular?: boolean;
  priceId: string; // ID du prix Stripe
  billingPeriod?: 'monthly' | 'yearly';
  isLegacy?: boolean;
  isPro?: boolean; // True for Pro subscriptions with custom branding
  isTaxIncluded: boolean; // True if price includes tax (TTC), false if price is before tax (HT)
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'legacy_monthly_unlimited',
    name: 'DPEWizard - Unlimited Power (Legacy)',
    description: 'Ancien abonnement mensuel à 15€',
    mode: 'subscription',
    price: 15.00,
    priceId: 'price_1RY8oXHgJ40en0Uj5l60WSyL',
    billingPeriod: 'monthly',
    isLegacy: true,
    isTaxIncluded: true,
    features: [
      'Analyses DPE - illimitées !',
      'Questions contextuelles avancées',
      'Recommandations personnalisées',
      'Moteur de règles complet',
      'Support prioritaire',
      'Rapports détaillés',
      'DPE projetés'
    ]
  },
  {
    id: 'monthly_unlimited',
    name: 'DPEWizard - Unlimited Power',
    description: 'Analyses DPE illimitées avec toutes les fonctionnalités avancées',
    mode: 'subscription',
    price: 19.90,
    priceId: 'price_1T9QlBEKanECu7buIN1sa9Wu',
    billingPeriod: 'monthly',
    isTaxIncluded: true,
    features: [
      'Analyses DPE - illimitées !',
      'Questions contextuelles avancées',
      'Recommandations personnalisées',
      'Moteur de règles complet',
      'Support prioritaire',
      'Rapports détaillés',
      'DPE projetés'
    ],
    popular: false
  },
  {
    id: 'yearly_unlimited',
    name: 'DPEWizard - Unlimited Power',
    description: 'Analyses DPE illimitées avec toutes les fonctionnalités avancées - 2 mois offerts',
    mode: 'subscription',
    price: 190.00,
    priceId: 'price_1TQmMxEKanECu7buEYHgzMIB',
    billingPeriod: 'yearly',
    isTaxIncluded: true,
    features: [
      'Analyses DPE - illimitées !',
      'Questions contextuelles avancées',
      'Recommandations personnalisées',
      'Moteur de règles complet',
      'Support prioritaire',
      'Rapports détaillés',
      'DPE projetés'
    ],
    popular: true
  },
  {
    id: 'monthly_unlimited_pro',
    name: 'DPEWizard - Unlimited Pro Agence',
    description: 'Toutes les fonctionnalités + branding personnalisé pour vos rapports PDF + multi-utilisateurs',
    mode: 'subscription',
    price: 99.00,
    priceId: 'price_1TQmF0EKanECu7bu0dq9AykZ',
    billingPeriod: 'monthly',
    isPro: true,
    isTaxIncluded: false,
    features: [
      'Analyses DPE - illimitées !',
      'Questions contextuelles avancées',
      'Recommandations personnalisées',
      'Moteur de règles complet',
      'Support prioritaire',
      'Rapports détaillés',
      'DPE projetés',
      'Rapports PDF avec votre logo et nom d\'entreprise',
      '1 compte partagé pour toute votre agence (ex : contact@monagence.fr)',
      'Session de 30 minutes en visioconférence avec le fondateur de la solution'
    ],
    popular: false
  },
  {
    id: 'yearly_unlimited_pro',
    name: 'DPEWizard - Unlimited Pro Agence',
    description: 'Toutes les fonctionnalités + branding personnalisé - 2 mois offerts',
    mode: 'subscription',
    price: 990.00,
    priceId: 'price_1TQmIpEKanECu7buqI0OqI7c',
    billingPeriod: 'yearly',
    isPro: true,
    isTaxIncluded: false,
    features: [
      'Analyses DPE - illimitées !',
      'Questions contextuelles avancées',
      'Recommandations personnalisées',
      'Moteur de règles complet',
      'Support prioritaire',
      'Rapports détaillés',
      'DPE projetés',
      'Rapports PDF avec votre logo et nom d\'entreprise',
      '1 compte partagé pour toute votre agence (ex : contact@monagence.fr)',
      'Session de 30 minutes en visioconférence avec le fondateur de la solution'
    ],
    popular: false
  },
  {
    id: 'one_time_credit',
    name: 'DPEWizard - Accès ponctuel',
    description: 'Pour tester l\'outil ou une utilisation occasionnelle',
    mode: 'payment',
    price: 9.90,
    priceId: 'price_1RYhWxEKanECu7buZqVlIB52',
    isTaxIncluded: true,
    features: [
      '1 analyse DPE complète',
      'Questions contextuelles avancées',
      'Recommandations personnalisées',
      'Moteur de règles complet',
      'Rapports détaillés',
      'DPE projetés'
    ]
  }
];

export const getProductById = (id: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.id === id);
};


export const isProSubscription = (priceId: string | null | undefined): boolean => {
  if (!priceId) return false;
  return STRIPE_PRODUCTS.some(product => product.priceId === priceId && product.isPro);
};

export const calculateYearlySavings = (monthlyPrice: number, yearlyPrice: number): number => {
  const monthlyTotal = monthlyPrice * 12;
  const savings = monthlyTotal - yearlyPrice;
  return Math.round((savings / monthlyTotal) * 100);
};